module.exports = __webpack_public_path__ + "f2c4b0e4cf83337acc23783057ec56.png";